import Container from "react-bootstrap/Container";
import React from "react";

class Team extends React.Component {
	render() {
		return (
				<Container className="section" id="Team" style={{marginTop: 50}}>
					<h1>Team</h1>
				</Container>
		);
	}
}
export default Team;